export default {
  title: 'Info',
  sections: {
    work_schedule: 'Horario: pedidos en línea',
    delivery_schedule: 'Horarios de entrega',
    delivery_costs: 'Costes de entrega',
    website: 'Sitio web',
  },
  labels: {
    delivery_fees: 'Importe mín. - {{threshold}}, Tarifa - {{fee}}',
  },
};
